import store from 'state/store'

export const getISOLocaleMidnightTime = ms => {
  const newDate = new Date(ms)
  newDate.setHours(0, 0, 0, 0)
  return newDate.toISOString()
}

export const getISOLocaleEndOfDay = ms => {
  const newDate = new Date(ms)
  newDate.setHours(23, 59, 59, 999)
  return newDate.toISOString()
}

export const dateFormatter = (ms, timeZone, options = {}) => {
  const { locale } = store.getState()?.auth || {}
  const { year = 'numeric', month = '2-digit', day = '2-digit' } = options
  return new Date(ms).toLocaleDateString(locale, {
    year: year,
    month: month,
    day: day,
    ...(timeZone ? { timeZone } : null),
  })
}

export const timeFormatter = (ms, timeZone, showTimeZone) => {
  const { locale } = store.getState()?.auth || {}
  return new Date(ms).toLocaleTimeString(locale, {
    hour: '2-digit',
    minute: '2-digit',
    ...(timeZone ? { timeZone } : null),
    ...(showTimeZone ? { timeZoneName: 'short' } : null),
  })
}

export const dateTimeFormatter = (ms, options = {}) => {
  const { dateFormatFull = false, reversed = false, timeZone = null, showTimeZone = false } = options
  if (!ms) return '---'
  const { locale } = store.getState()?.auth || {}
  const date = new Date(ms).toLocaleDateString(locale, {
    ...{ year: 'numeric', month: dateFormatFull ? 'long' : '2-digit', day: dateFormatFull ? 'numeric' : '2-digit' },
    ...(timeZone ? { timeZone } : null),
  })
  const time = timeFormatter(ms, timeZone, showTimeZone)

  if (reversed) return `${time}, ${date}`
  return `${date}, ${time}`
}

export const dateUnixFormatter = inputDate => {
  if (!inputDate) return ''
  const unixTimeStamp = new Date(inputDate).getTime()

  return unixTimeStamp
}

export const capitalize = str => {
  if (!str) return ''
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase()
}

export const formatFullAddress = location => {
  return [location?.address, location?.city, location?.state].filter(element => !!element).join(', ')
}

export const convertShippingInfoToCityStateZip = shippingInfo =>
  `${shippingInfo?.city || ''}${shippingInfo?.state || shippingInfo?.zip ? ',' : ''} ${shippingInfo?.state || ''} ${
    shippingInfo?.zip || ''
  }`

export const formatCityState = location => [location?.city, location?.state].filter(element => !!element).join(', ')

export const formatAddress = (addresses, multiline, emptyLine = false) => {
  if (!addresses?.address1 && !addresses?.address2 && emptyLine) return '---'
  const address = addresses?.address || addresses?.address1 || ''
  const address2 = addresses?.address2 || ''

  if (multiline) {
    if (address2) {
      return `${address},
      ${address2}`
    }
    return `${address}`
  }

  return `${address}${address && address2 ? `, ${address2}` : address2}`
}

export const makeCommaSeparatedString = array => {
  const listStart = array.slice(0, -1).join(', ')
  const listEnd = array.slice(-1)
  const andSeparator = array.length > 2 ? ', and ' : ' and '
  const separators = array.length <= 1 ? '' : andSeparator

  return [listStart, listEnd].join(separators)
}

// pulled and modified from https://github.com/sindresorhus/round-to
const round = (method, number, precision = 0) => {
  if (precision === Number.POSITIVE_INFINITY) return number

  if (!Number.isInteger(precision)) {
    throw new TypeError('Expected precision to be an integer')
  }

  const isRoundingAndNegative = method === 'round' && number < 0
  const formattedNumber = isRoundingAndNegative ? Math.abs(number) : number

  const power = 10 ** precision
  const result =
    ['round', 'ceil', 'floor'].indexOf(method) > -1
      ? Math[method](Number((formattedNumber * power).toPrecision(15))) / power
      : 0

  return isRoundingAndNegative ? -result : result
}

export const roundTo = round.bind(undefined, 'round')
export const roundToUp = round.bind(undefined, 'ceil')
export const roundToDown = round.bind(undefined, 'floor')

export const formatPhoneNumber = phoneNumberString => {
  if (!phoneNumberString || phoneNumberString.length !== 10 || !/^\d{10}$/.test(phoneNumberString)) {
    return phoneNumberString
  }

  const areaCode = phoneNumberString.slice(0, 3)
  const centralOfficeCode = phoneNumberString.slice(3, 6)
  const stationCode = phoneNumberString.slice(6, 10)

  return `(${areaCode}) ${centralOfficeCode}-${stationCode}`
}

export const formatCustomerLocationString = (customerName, locName) => {
  return [customerName, locName].filter(text => !!text).join(' - ') || '-'
}

export const formatMaterialName = material => {
  if (!material.commonName && !material.code) return ''
  return `${material.commonName} (${material.code})${material.overrideName ? ` - ${material.overrideName}` : ''}`
}

export const countryCodeToName = (countryCode, languageCode) => {
  try {
    const regionNames = new Intl.DisplayNames([languageCode || 'en'], { type: 'region' })
    return regionNames.of(countryCode) || countryCode
  } catch {
    return countryCode
  }
}
